export default __webpack_public_path__ + "static/media/tutorial06.c3348ae6.jpg";